import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  UPDATE_MANAGER_HOLIDAY_REQUEST,
  UPDATE_MANAGER_HOLIDAY_SUCCESS,
  UPDATE_MANAGER_HOLIDAY_FAILURE,
  ADD_MANAGER_HOLIDAY_REQUEST,
  ADD_MANAGER_HOLIDAY_SUCCESS,
  ADD_MANAGER_HOLIDAY_FAILURE,
  DELETE_MANAGER_HOLIDAY_REQUEST,
  DELETE_MANAGER_HOLIDAY_SUCCESS,
  DELETE_MANAGER_HOLIDAY_FAILURE
} from "../../Constants";

function requestUpdateHoliday() {
  return {
    type: UPDATE_MANAGER_HOLIDAY_REQUEST,
    isFetching: true
  };
}

function updateHolidaySuccess(data) {
  return {
    type: UPDATE_MANAGER_HOLIDAY_SUCCESS,
    isFetching: false,
    data
  };
}

function updateHolidayError(errorMessage) {
  return {
    type: UPDATE_MANAGER_HOLIDAY_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestaddHoliday() {
  return {
    type: ADD_MANAGER_HOLIDAY_REQUEST,
    isFetching: true
  };
}

function addHolidaySuccess(data) {
  return {
    type: ADD_MANAGER_HOLIDAY_SUCCESS,
    isFetching: false,
    data
  };
}

function addHolidayError(errorMessage) {
  return {
    type: ADD_MANAGER_HOLIDAY_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestDeleteHoliday() {
  return {
    type: DELETE_MANAGER_HOLIDAY_REQUEST,
    isFetching: true
  };
}

function deleteHolidaySuccess(data) {
  return {
    type: DELETE_MANAGER_HOLIDAY_SUCCESS,
    isFetching: false,
    data
  };
}

function deleteHolidayError(errorMessage) {
  return {
    type: DELETE_MANAGER_HOLIDAY_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const updateManagerHoliday = payload => (dispatch, getState) => {
  dispatch(requestUpdateHoliday());
  managerTimesheet
    .updateHolidayManager(payload)
    .then(res => {
      dispatch(updateHolidaySuccess(res));
    })
    .catch(err => dispatch(updateHolidayError(err)));
};

export const addManagerHoliday = payload => (dispatch, getState) => {
  dispatch(requestaddHoliday());
  managerTimesheet
    .addHolidayManager(payload)
    .then(res => {
      dispatch(addHolidaySuccess(res));
    })
    .catch(err => dispatch(addHolidayError(err)));
};

export const deleteManagerHoliday = payload => (dispatch, getState) => {
  dispatch(requestDeleteHoliday());
  managerTimesheet
    .deleteHolidayManager(payload)
    .then(res => {
      dispatch(deleteHolidaySuccess(res));
    })
    .catch(err => dispatch(deleteHolidayError(err)));
};

export const holidaySaveReset = payload => (dispatch, getState) => {
  dispatch(addHolidaySuccess(""));
};
